import { SecuritySettings } from '@widgets/security-settings';

export function SecurityPage() {
  return <SecuritySettings />;
}
